<!-- @file 在线咨询企业微信二维码弹窗 -->
<template>
  <plv-dialog
    v-model="visible"
    class="c-online-consultation-dialog"
    custom-style
    mask-background="rgba(0, 0, 0, 0.4)"
    :close-on-click-mask="false"
  >
    <section class="c-online-consultation-dialog__content">
      <span
        class="c-online-consultation-dialog__diffuse-glow"
        aria-hidden="true"
      ></span>
      <button
        class="c-online-consultation-dialog__close"
        type="button"
        aria-label="关闭"
        @click="hide"
      >
        <span
          class="c-online-consultation-dialog__close-icon"
          aria-hidden="true"
        >
          <svg
            width="1em"
            height="1em"
            focusable="false"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M6.99,18.30L5.70,17.01L10.71,12.00L5.70,6.99L6.99,5.70L12.00,10.71L17.02,5.70L18.31,7.00L13.30,12.00L18.30,17.01L17.01,18.30L12.00,13.30L6.99,18.30Z"
            />
          </svg>
        </span>
      </button>

      <img
        class="c-online-consultation-dialog__header"
        src="./images/dialog-header-zh-cn.png"
        alt="请添加小助理，立即联系 1V1 专属客服解答产品疑问"
      />

      <div class="c-online-consultation-dialog__qrcode-card">
        <img
          class="c-online-consultation-dialog__qrcode"
          src="./images/online-consultation-qrcode.png"
          alt="在线咨询二维码"
        />
      </div>

      <div class="c-online-consultation-dialog__benefits">
        <p class="c-online-consultation-dialog__benefits-title">
          添加后可获得福利
        </p>
        <div class="c-online-consultation-dialog__benefit-list">
          <article class="c-online-consultation-dialog__benefit-card">
            <div class="c-online-consultation-dialog__benefit-copy">
              <p class="c-online-consultation-dialog__benefit-title">
                产品使用手册
              </p>
              <p class="c-online-consultation-dialog__benefit-subtitle">
                图文教程指引
              </p>
            </div>
            <span class="c-online-consultation-dialog__product-guide-frame">
              <img
                class="c-online-consultation-dialog__product-guide"
                src="./images/product-guide.png"
                alt=""
              />
            </span>
          </article>
          <article class="c-online-consultation-dialog__benefit-card">
            <div class="c-online-consultation-dialog__benefit-copy">
              <p class="c-online-consultation-dialog__benefit-title">
                专属真人客服
              </p>
              <p class="c-online-consultation-dialog__benefit-subtitle">
                1V1 在线答疑
              </p>
            </div>
            <span class="c-online-consultation-dialog__human-service-frame">
              <img
                class="c-online-consultation-dialog__human-service"
                src="./images/human-service.png"
                alt=""
              />
            </span>
          </article>
        </div>
      </div>
    </section>
  </plv-dialog>
</template>

<script>
export default {
  name: 'OnlineConsultationDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    hide() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss">
.c-online-consultation-dialog__content {
  position: relative;
  box-sizing: border-box;
  width: 400px;
  height: 530px;
  max-height: 85%;
  padding: 30px 30px 0;
  overflow: hidden;
  font-family:
    'Helvetica Neue',
    Helvetica,
    'PingFang SC',
    'Hiragino Sans GB',
    'Microsoft YaHei',
    SimSun,
    sans-serif;
  color: #1d2129;
  text-align: center;
  background:
    radial-gradient(
      circle at 0% 48%,
      rgba(105, 240, 210, 0.24) 0 14%,
      transparent 42%
    ),
    linear-gradient(160deg, #eff7fd 0%, #deebff 54%, #d7f4f5 100%);
  border-radius: 16px;
  box-shadow: 0 6px 30px -5px rgba(0, 0, 0, 0.2);
}

.c-online-consultation-dialog__diffuse-glow {
  position: absolute;
  top: -98px;
  left: 301px;
  box-sizing: border-box;
  width: 188px;
  height: 188px;
  pointer-events: none;
  background: linear-gradient(
    43deg,
    rgba(158, 208, 248, 0.4) 16%,
    #6aaafd 51%
  );
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  opacity: 0.6;
}

.c-online-consultation-dialog__close {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  font-size: 24px;
  color: #000;
  cursor: pointer;
  background: transparent;
  border: 0;
}

.c-online-consultation-dialog__header {
  position: relative;
  z-index: 1;
  display: block;
  width: 250px;
  height: 73px;
  margin: -8px auto -15px;
}

.c-online-consultation-dialog__qrcode-card {
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  display: block;
  width: 100%;
  height: 274px;
  padding: 0;
  margin: 24px auto 0;
  background:
    url('./images/qrcode-card-bg-zh-cn.png') center / 340px 274px
    no-repeat;
}

.c-online-consultation-dialog__qrcode {
  position: absolute;
  top: 32px;
  left: 50%;
  display: block;
  width: 146px;
  height: 146px;
  transform: translateX(-50%);
}

.c-online-consultation-dialog__benefits {
  position: relative;
  box-sizing: border-box;
  height: 152px;
  padding: 44px 12px 14px;
  margin: -34px 0 0;
  text-align: left;
  background: linear-gradient(
    246deg,
    #d8d8d8 0%,
    #ffd296 0%,
    #ff7a2a 98%
  );
  border-radius: 0 0 16px 16px;
}

.c-online-consultation-dialog__benefits-title {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #fff;
  text-align: center;
}

.c-online-consultation-dialog__benefit-list {
  display: flex;
  gap: 8px;
}

.c-online-consultation-dialog__benefit-card {
  position: relative;
  box-sizing: border-box;
  flex: 1;
  height: 56px;
  padding: 6px 10px;
  overflow: hidden;
  background: #fee1d0;
  border-radius: 8px;
}

.c-online-consultation-dialog__benefit-copy {
  position: relative;
  z-index: 1;
}

.c-online-consultation-dialog__benefit-title {
  max-width: 100px;
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #773105;
}

.c-online-consultation-dialog__benefit-subtitle {
  max-width: 100px;
  margin: 4px 0 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  color: #773105;
  opacity: 0.6;
}

.c-online-consultation-dialog__product-guide-frame {
  position: absolute;
  top: 50%;
  right: 6px;
  width: 41px;
  height: 38px;
  overflow: hidden;
  transform: translateY(-50%);
}

.c-online-consultation-dialog__product-guide {
  position: absolute;
  top: -16px;
  left: -32px;
  display: block;
  width: auto;
  max-width: none;
  height: 74px;
}

.c-online-consultation-dialog__human-service-frame {
  position: absolute;
  top: 50%;
  right: 8px;
  width: 33px;
  height: 42px;
  overflow: hidden;
  transform: translateY(-50%);
}

.c-online-consultation-dialog__human-service {
  display: block;
  width: 33px;
  max-width: none;
  height: 42px;
}
</style>
